import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";

function ChartOfAccountClassification({ show, onHide }) {
  const { backendUrl, token } = useAuth();
  const { data } = useQuery(
    ["ACCOUNT_CLASSIFICATION"],
    async () => {
      //

      let response = await fetch(
        `${backendUrl}/api/accounts/account-classification`,
        {
          method: "GET",
          headers: {
            Accept: "Application/json",
            "Content-Type": "Application/json",
          },
          credentials: "include",
        }
      );

      if (!response.ok) {
        response = await response.json();
        throw new Error(response.message);
      }
      const { data } = await response.json();
      return data;
    },
    {
      keepPreviousData: true,
    }
  );

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      fullscreen
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Account Types
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          {data?.accountClassificationWithTypes
            ?.filter(item => !isEmpty(item?.allAccountDescs))
            .map(item => (
              <div key={item.AccountType} className="col-md-4">
                <p className="mb-3">
                  {" "}
                  <b>{item.AccountType}</b>
                </p>
                <Table striped bordered hover size="sm">
                  <tbody>
                    {item?.allAccountDescs?.map(desc => (
                      <tr key={desc.AccountDesc}>
                        {/* <td>{desc.AccountType}</td> */}
                        <td>{desc.AccountDesc}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ChartOfAccountClassification;
